var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vuetify-audio',{staticClass:"audio-wrapper",attrs:{"file":_vm.file,"color":_vm.color,"pathaudio":_vm.path,"flat":"","type":_vm.type,"title":_vm.title}})
}
var staticRenderFns = []

export { render, staticRenderFns }